import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Quote from './components/Quote';
import SummaryPage from './order/SummaryPage';
import { OrderProvider } from './order/OrderContext';
import LoginPage from './account/LoginPage';
import RegisterPage from './account/RegisterPage';
import AccountPage from "./account/AccountPage";
import ActivatePage from './account/ActivatePage';
import ResetPasswordPage from './account/ResetPasswordPage';
import { AuthProvider } from './account/AuthContext';
import { getToken } from './utils/token';
import OrderSuccessPage from './order/OrderSuccessPage';



// Komponent ochronny dla stron po zalogowaniu
const PublicRoute = ({ children }) => {
    const token = getToken();
    if (token) {
        window.location.replace('/account');
        return null;
    }
    return children;
};

// Komponent ochronny dla stron wymagających logowania
const PrivateRoute = ({ children }) => {
    const token = getToken();
    if (!token) {
        window.location.replace('/login');
        return null;
    }
    return children;
};

// Główny komponent aplikacji - tylko routing
function App() {
    const location = useLocation();

    // resetuj scroll przy każdej zmianie route
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <AuthProvider>
        <OrderProvider>
        <Routes>
        <Route path="/" element={<Navigate to="/quote" replace />} />
        <Route path="/activate" element={<ActivatePage />} />
        <Route path="/forgotpass" element={<ResetPasswordPage />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/quote/order" element={<SummaryPage />} />
        <Route path="/login" element={
            <PublicRoute>
            <LoginPage />
            </PublicRoute>
        } />
        <Route path="/register" element={
            <PublicRoute>
            <GoogleReCaptchaProvider
            reCaptchaKey="6Lfv3v8qAAAAAPMiRyEo3Q8dTqBMF2Q7c_SAmMzF"
            >
            <RegisterPage />
            </GoogleReCaptchaProvider>
            </PublicRoute>
        } />
        <Route path="/account/*" element={
            <PrivateRoute>
            <AccountPage />
            </PrivateRoute>
        } />
        <Route path="/order-success" element={<OrderSuccessPage />} />
        </Routes>
        </OrderProvider>
        </AuthProvider>
    );
}

export default App;
